import { getHttpService } from '@/services/HttpService';
import { error } from '@/utils/error';
import { CLIENT_CONTROLLER } from '@/constants';

interface DentalContentResponse {
    data: {
        isSucces: boolean;
        tvKeuzehulpResponse: DentalContent;
    };
}

interface DentalContent {
    vragen: string[];
    adviezen: string[];
}

const HttpService = getHttpService();

const getContent = async (brand: string): Promise<DentalContent> => {
    const path = '/clientcontroller/salesfunnelclient/ophalentvkeuzehulpcontent';
    const payload = {
        Propositie: brand
    };
    const { data } = (await HttpService.post(path, payload)) as DentalContentResponse;

    if (data.isSucces === false) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path,
            payload: JSON.stringify(payload)
        });
    }

    return data.tvKeuzehulpResponse;
};

export default {
    getContent
};
